


















































































































































































































import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import CField from "@/components/form/CField.vue";
import { CoursesListClass } from "@/classes/list/CoursesListV2Class";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import { courseApi, learningRequestApi } from "@/getinfo-api";
import {
  getCurrentCompanyId,
  getCurrentEmployee,
  getCurrentUserId
} from "@/plugins/roles";
import CustomButton from "@/components/form/CustomButton.vue";
import { StatusProfile as IStatusProfile } from "@/api-v2/learning-requests/models";
import { LearningRequestCreate as ILearningRequestCreate } from "@/api-v2/learning-requests/models";
import { Student as IStudent, Course as ICourse } from "@/api-v2/course/models";
import StudentTable from "@/components/students/StudentTable.vue";
import { uniqBy } from "lodash";
import CPageButtons from "@/components/form/CustomPage/CPageButtons.vue";
import EditorWithFile from "@/components/EditorWithFile.vue";
import DocumentNumberInput from "@/components/form/DocumentNumberInput.vue";
import { EmployeesListClass } from "@/classes/list/EmployeesListClass";
import { ContractorsListClass } from "@/classes/list/ContractorsListClass";
import { StudentsListParams } from "@/getinfo-api/students";

@Component({
  components: {
    DocumentNumberInput,
    EditorWithFile,
    CPageButtons,
    StudentTable,
    CustomButton,
    CSingleSelect,
    CField,
    CBlock
  }
})
export default class LearningRequestFormCreateV2 extends Vue {
  @Prop() value!: any;
  @Prop({ default: false }) edit!: boolean;
  @Prop() addedStudents!: IStudent[];
  coursesList: CoursesListClass = new CoursesListClass(
    {
      companyId: this.selectedCompany,
      limit: 900
    },
    this.value ? this.value.courseId : undefined
  );
  isShowCourseStudents: boolean = false;
  profiles: Array<IStatusProfile> = [];
  profile!: IStatusProfile;
  course!: ICourse;
  coursePrice: number = 0;
  learningRequestForm: ILearningRequestCreate = {
    responsibleId: "",
    contractorId: "",
    price: 0,
    formedAt: new Date(),
    number: "",
    courseId: "",
    profileId: "",
    description: "",
    studentIds: [],
    statusId: ""
  };
  contractorType: string = "juridical";
  checkedStudents: Array<IStudent> = [];
  choosedStudents: Array<IStudent> = [];
  isCanEditPrice: boolean = false;
  employees: EmployeesListClass = new EmployeesListClass(
    {
      id: this.selectedCompany,
      roles: ["learning_request_manager"],
      limit: 900
    },
    this.selectedCompany,
    this.learningRequestForm.responsibleId
  );
  form: StudentsListParams = {
    offset: 0,
    limit: 15,
    userIds: [],
    companyId: getCurrentCompanyId()
  };

  contractorList: ContractorsListClass = new ContractorsListClass(
    {
      companyId: this.selectedCompany,
      type: this.contractorType
    },
    this.value ? this.value.contractorId : undefined
  );

  data() {
    return {
      profile: undefined,
      course: undefined
    };
  }

  get courseSingle() {
    return this.coursesList.singleResult;
  }

  get contractorSingle() {
    return this.contractorList.singleResult;
  }

  @Watch("courseSingle")
  checkCourseSingle() {
    this.course = this.courseSingle;
  }

  @Watch("contractorSingle")
  checkContractorSingle() {
    this.contractorType = this.contractorSingle.type;
  }

  @Watch("contractorType")
  loadType() {
    this.checkClientType();
  }

  @Watch("profile", { immediate: true, deep: true })
  checkProfileId() {
    if (this.profile) {
      this.$nextTick(() => {
        this.learningRequestForm.statusId = this.profile.statuses[0].id;
      });
    }
  }

  checkClientType() {
    //@ts-ignore
    this.contractorList.params.type = !this.contractorType
      ? undefined
      : this.contractorType;
    this.contractorList.params.offset = 0;
    this.contractorList.listItems = [];
    this.contractorList.list();
  }

  get selectedCompany() {
    return getCurrentCompanyId();
  }

  getProfiles() {
    learningRequestApi.StatusProfiles.listProfiles(this.selectedCompany).then(
      res => {
        this.profiles = res.data;
        if (!this.edit) {
          this.profile = this.profiles[0];
          this.learningRequestForm.profileId = this.profiles[0].id;
        }
        if (this.edit) {
          let index = this.profiles.findIndex(
            el => el.id === this.learningRequestForm.profileId
          );
          this.profile = this.profiles[index];
        }
      }
    );
  }

  showAddStudents() {
    this.checkedStudents = [];
    this.isShowCourseStudents = !this.isShowCourseStudents;
  }

  addStudents() {
    this.choosedStudents = [...this.choosedStudents, ...this.checkedStudents];
    this.choosedStudents = uniqBy(this.choosedStudents, "id");
  }

  removeFromAdded(students: Array<IStudent>) {
    this.choosedStudents = this.choosedStudents.filter(
      ({ id }) => !students.map(({ id }) => id).includes(id)
    );
  }

  @Watch("choosedStudents", { deep: true })
  checkChoosedStudents() {
    this.learningRequestForm.studentIds = this.choosedStudents.map(
      ({ id }) => id
    );
  }

  @Watch("learningRequestForm", { deep: true })
  checkLearningRequestForm() {
    this.$emit("input", this.learningRequestForm);
  }

  @Watch("learningRequestForm.courseId")
  checkFormCourse() {
    this.checkedStudents = [];
    this.choosedStudents = [];
    this.isShowCourseStudents = false;
  }

  @Watch("course")
  checkCourse() {
    this.learningRequestForm.courseId = this.course.id;
    courseApi.CourseInfo.getCourseInfo(this.course.id).then(res => {
      if (res.data.price) {
        this.coursePrice = this.$converter.getPrice(res.data.price);
      }
    });
  }

  createStatusProfile() {
    learningRequestApi.StatusProfiles.createProfile({
      title: "test",
      description: "string",
      statuses: [
        {
          title: "string",
          description: "string"
        }
      ],
      companyId: this.selectedCompany
    });
  }

  get formattedPrice() {
    if (this.coursePrice && this.course && !this.isCanEditPrice) {
      this.learningRequestForm.price = +(
        this.choosedStudents.length * this.coursePrice
      ).toFixed(0);
    }
    return this.learningRequestForm.price;
  }

  set formattedPrice(value) {
    this.learningRequestForm.price = value;
  }

  @Watch("value", { immediate: true, deep: true })
  checkValue() {
    if (this.edit) {
      this.isCanEditPrice = true;
      this.learningRequestForm = this.value;
      if (this.addedStudents && this.addedStudents.length) {
        this.choosedStudents = this.addedStudents;
      }
    }
  }

  get currentUser() {
    return getCurrentUserId();
  }

  get currentEmployee() {
    return getCurrentEmployee();
  }

  @Watch("currentEmployee", { immediate: true })
  checkEmployee() {
    if (
      !this.edit &&
      this.currentEmployee &&
      this.currentEmployee.roles.some(
        (el: string) => el === "learning_request_manager"
      )
    ) {
      this.learningRequestForm.responsibleId = this.currentEmployee.id;
    }
  }

  created() {
    this.getProfiles();
  }
}
